import { Modal } from '@diamond/shared/ui';

import { FormHighlight } from '../components/form-highlight/form-highlight';

interface HighlightCreateModalProps {
  isOpen: boolean;
  modalState: 'create' | 'edit' | 'duplicate';
  id: string;
  allProductHighlightData: Array<{
    id: string;
    title: string;
    product_highlight_type: 'general' | 'specific' | undefined;
    total_business_types: number;
    total_shiptos: number;
  }>;
  onClose: () => void;
  refetch: () => void;
}

export function HighlightCreateModal({
  isOpen,
  modalState,
  id,
  allProductHighlightData,
  onClose,
  refetch,
}: HighlightCreateModalProps) {
  if (!isOpen) {
    return null;
  }

  const formModalContentProps = {
    // Allow dropdowns to render beyond content without clipping
    overflow: 'visible',
    mt: 0,
    w: { base: '100%', md: '100%', lg: '1000px' },
    maxW: { base: '100%', md: '100%', lg: '1000px' },
  };

  const getModalTitle = () => {
    switch (modalState) {
      case 'edit':
        return 'Edit Highlight Product';
      case 'duplicate':
        return 'Duplicate Highlight Product';
      default:
        return 'Tambahkan Highlight Product';
    }
  };

  return (
    <Modal
      title={getModalTitle()}
      size="xl"
      name="form-add-highlight-product"
      isOpen={isOpen}
      onClose={onClose}
      // Scroll the page behind the modal rather than inside ModalBody
      scrollBehavior="outside"
      isCentered
      hideAction
      modalBodyProps={{ pb: 0 }}
      modalContentProps={formModalContentProps}
      modalHeaderProps={{ fontSize: { base: '16px', md: '18px' }, pb: 2 }}
    >
      <FormHighlight
        id={id}
        modalState={modalState}
        allProductHighlightData={allProductHighlightData}
        onClose={onClose}
        refetch={refetch}
      />
    </Modal>
  );
}
